<template lang="html">
  <div class="logo">
    <router-link :to="{name: 'whats-new'}" v-if="!whiteLabel">
      <span class="word-primary">Page</span>
      <span class="word-secondary">Maker</span>
      <span class="word-primary">Pro</span>
    </router-link>

    <router-link :to="{name: 'whats-new'}" v-else>
      <span class="word-primary">New</span>
      <span class="word-secondary">Website</span>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'Logo',

  props: {
    whiteLabel: Boolean
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.logo
  cursor: default

  span
    font-size: 24px
    text-transform: capitalize
    letter-spacing: 1px
    transition: all .1s ease-in-out

  .beta
    font-size: 10px
    position: relative
    top: -14px
    font-family: 'nexa-light'
    color: rgba(0, 0, 0, 0.5)

  .word-primary
    font-family: 'nexa-light'

    @include themify($themes)
      color: themed('logo-primary')

  .word-secondary
    font-family: 'nexa-bold'
    margin: 0 1px

    @include themify($themes)
      color: themed('logo-secondary')

  .in-builder-mode &
    span
      color: #fff!important
</style>
